import { customElement } from 'lit/decorators.js';
import { TefComsCancelButton } from '@src/components/TefComsCancelButton.js';
import { componentStateStore } from '@src/store/index.js';

@customElement('tef-coms-back-button')
export class TefComsBackButton extends TefComsCancelButton {
  variant: string = 'outline';

  handleClick() {
    componentStateStore.disabled = true;

    this.triggerEvent({
      name: 'action/CANCEL_MICROFRONTEND',
      level: 'info',
      message: 'cancel action invoked',
    });
  }
}
